import { ButtonBase, styled } from '@mui/material';
import React, { ReactNode } from 'react';

type DynamicCardUnstyledProps = {
  className?: string;
  loading?: boolean;
  onClick?(): void;
  children: ReactNode;
  'data-testid'?: string;
};

const DynamicCardUnstyled = React.forwardRef<HTMLDivElement, DynamicCardUnstyledProps>(function DynamicCardUnstyled(
  props,
  ref,
) {
  const { children, onClick, loading, className, 'data-testid': dataTestId } = props;
  if (!onClick) {
    return (
      <div ref={ref} className={className} data-testid={dataTestId}>
        {children}
      </div>
    );
  }

  return (
    <ButtonBase
      ref={ref}
      component="div"
      className={className}
      disabled={loading}
      onClick={onClick}
      data-testid={dataTestId}>
      {children}
    </ButtonBase>
  );
});

type DynamicCardProps = {
  loading?: boolean;
  disabled?: boolean;
  children: ReactNode;
};

export const DynamicCard = styled(DynamicCardUnstyled)<DynamicCardProps>(
  // TODO: refactor to configure it using MUI theme and component variants
  ({ theme, loading, disabled }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    overflow: 'hidden',
    borderRadius: 16,
    opacity: disabled || loading ? 0.5 : 1,
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
  }),
);
